import CityPageTemplate from "../city-template/CityPageTemplate";
import { rawlinsConfig } from "./data";

export default function RawlinsPage() {
  return <CityPageTemplate config={rawlinsConfig} />;
}